export default __webpack_public_path__ + "static/media/ceraveMoisturizingCream.c512fb36.jpg";